export default "__VITE_ASSET__DKu_l$ob__"